import React from "react";
import styled from "styled-components";
import { Container } from "../globalStyle";
const InfoSec = styled.div`
  color: #fff;
  padding: 50px 0;
  animation: example infinite;
  animation-duration: 4s;
  @keyframes example {
    0% {
      background: #101522;
    }
    25% {
      background: #4b59f7;
    }
    50% {
      background: #101522;
    }
    75% {
      background: #4b59f7;
    }
    100% {
      background: #101522;
    }
  }
`;

const InfoSecNew = styled.div`
  color: #fff;
  padding: 50px 0;
`;

const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 0px;
  vertical-align: center;
`;

const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "#f7f8fa" : "#1c2237")};
`;
const TopLine = styled.div`
  color: ${({ lightTopLine }) => (lightTopLine ? "#a9b3c1" : "#4B59F7")};
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
`;

const Project = ({
  lightText,
  headline,
  lightBg,
  lightTopLine,
  topLine,
  animate,
  id,
}) => {
  return (
    <>
      {animate ? (
        <InfoSec id={id} lightBg={lightBg}>
          <Container>
            <InfoRow>
              <TextWrapper>
                <Heading lightText={lightText}>{headline}</Heading>
                <TopLine lightTopLine={lightTopLine}>{topLine}</TopLine>
              </TextWrapper>
            </InfoRow>
          </Container>
        </InfoSec>
      ) : (
        <InfoSecNew lightBg={lightBg}>
          <Container>
            <InfoRow>
              <TextWrapper>
                <Heading lightText={lightText}>{headline}</Heading>
                <TopLine lightTopLine={lightTopLine}>{topLine}</TopLine>
              </TextWrapper>
            </InfoRow>
          </Container>
        </InfoSecNew>
      )}
    </>
  );
};

export default Project;
